import React from "react";
import { Link } from "react-router-dom";
import siteConfig from "../config/siteConfig";
import "../css/footer.scss";

function Footer() {
  const toTop = () => window.scrollTo({ top: 0, behavior: "smooth" });

  return (
    <footer className="site-footer" role="contentinfo">
      <section className="footer-intro" aria-label="Customer support">
        <span>Questions / orders / product details</span>
        <a href={`mailto:${siteConfig.contact.email}`}>{siteConfig.contact.email}</a>
      </section>

      <div className="footer-main">
        <nav className="footer-links" aria-label="Customer care">
          <p className="footer-kicker">Support</p>
          <Link to="/contact" onClick={toTop}>
            Contact
          </Link>
          <Link to="/shipping" onClick={toTop}>
            Delivery
          </Link>
          <Link to="/returns" onClick={toTop}>
            Returns
          </Link>
          <Link to="/size-guide" onClick={toTop}>
            Measurements
          </Link>
          <Link to="/care-guide" onClick={toTop}>
            Garment care
          </Link>
          <Link to="/payment-security" onClick={toTop}>
            Payment &amp; security
          </Link>
        </nav>

        <nav className="footer-links" aria-label="Legal information">
          <p className="footer-kicker">Information</p>
          <Link to="/about" onClick={toTop}>
            Company
          </Link>
          <Link to="/terms" onClick={toTop}>
            Terms &amp; conditions
          </Link>
          <Link to="/privacy" onClick={toTop}>
            Privacy policy
          </Link>
          <Link to="/cookies" onClick={toTop}>
            Cookie policy
          </Link>
          <Link to="/faqs" onClick={toTop}>
            FAQs
          </Link>
          <Link to="/accessibility" onClick={toTop}>
            Accessibility
          </Link>
        </nav>

        <section
          className="footer-links footer-legal"
          aria-label="Company information"
        >
          <p className="footer-kicker">Operator</p>
          <a href={`mailto:${siteConfig.contact.email}`}>
            {siteConfig.contact.email}
          </a>
          <p>{siteConfig.legalEntity.name}</p>
          <address>{siteConfig.legalEntity.address}</address>
        </section>
      </div>

      <div className="footer-bottom">
        <div className="footer-locale">
          <span>
            {siteConfig.currency.code} {siteConfig.currency.symbol}
          </span>
        </div>
        <div className="footer-company">
          <p>
            © {new Date().getFullYear()} {siteConfig.displayName}
          </p>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
